import {enableProdMode, inject, provideAppInitializer} from '@angular/core'
import {registerLocaleData} from '@angular/common'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {MatPaginatorIntl} from '@angular/material/paginator'
import {SpbPaginatorSv} from '@sparbanken-syd/sparbanken-syd-theme'
import {
  MAT_LUXON_DATE_ADAPTER_OPTIONS,
  MAT_LUXON_DATE_FORMATS,
  provideLuxonDateAdapter
} from '@angular/material-luxon-adapter'
import {provideHttpClient, withInterceptors} from '@angular/common/http'
import {provideRouter, withHashLocation} from '@angular/router'
import {
  authInterceptor,
  ConfigService,
  IConfig,
  ILoginSettings,
  responseInterceptor,
  SPB_LOGIN_SETTINGS,
  SPS_CONFIG
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {environment} from '../environments/environment'
import {LOCAL_STORAGE} from './application/localstorage.provider'
import routes from './app-routes'
import {MAT_DATE_LOCALE} from '@angular/material/core'
import {ENVIRONMENT} from './application/environment.provider'
import {MAT_CARD_CONFIG, MatCardConfig} from '@angular/material/card'
import {HANDLAGGARE, KUNDCENTER} from './application/types'
import {xlsxProvider} from './application/xlsx.provider'
import {WINDOW} from './application/window.provider'
import localeSv from '@angular/common/locales/sv'

registerLocaleData(localeSv, 'sv')

if (environment.production) {
  enableProdMode()
}

const configServiceConfig: IConfig = {
  authServiceUrl: environment.authServiceUrl,
  domain: environment.domain,
  adminRoles: [HANDLAGGARE, KUNDCENTER]
}


export const appConfig = {
  providers: [
    /**
     * We need a provide a config here...
     */
    {provide: SPS_CONFIG, useValue: configServiceConfig},
    {
      provide: SPB_LOGIN_SETTINGS, useValue: {
        text: 'Välkommen till Omsättningsverktyg. För att komma igång behöver du logga in med BankID.',
        buttonText: 'Logga in med BankID',
        route: ['/', 'landing']
      } as ILoginSettings
    },
    {provide: ENVIRONMENT, useValue: environment},
    provideAppInitializer(() => inject(ConfigService).bootstrap()),

    // Needed by filter service
    {provide: LOCAL_STORAGE, useValue: localStorage},
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        floatLabel: 'always',
        hideRequiredMarker: true,
        appearance: 'outline',
        subscriptSizing: 'dynamic'
      }
    },
    {provide: WINDOW, useValue: globalThis},
    xlsxProvider,
    {provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'} as MatCardConfig},
    // Paginator in Swedish.
    {provide: MatPaginatorIntl, useClass: SpbPaginatorSv},
    // Required for 2025-07-29 format
    {provide: MAT_DATE_LOCALE, useValue: 'sv-SE'},
    {
      provide: MAT_LUXON_DATE_ADAPTER_OPTIONS,
      useValue: {useUtc: true, firstDayOfWeek: 1}
    },
    provideLuxonDateAdapter(MAT_LUXON_DATE_FORMATS),

    provideHttpClient(
      withInterceptors([authInterceptor, responseInterceptor])),
    provideRouter(routes,
      withHashLocation())
  ]
}